export default __webpack_public_path__ + "static/media/Menu_Hoodie_women.d1c2ad0a.svg";